import React, { useEffect, useState } from "react";
import Select from "react-select";
import validator from "validator";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Image,
} from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import {
  productAdded,
  productGetById,
  productUpdated,
} from "../../../Redux/productsSlice";
import { fetchCategories } from "../../../Redux/categoriesSlice";
import { fetchBrands } from "../../../Redux/brandsSlice";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

function AjouterProduct() {
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>
          <i className="fas fa-check-circle"></i>
          {msg}
        </strong>,
      );
    else
      toast.error(
        <strong>
          <i className="fas fa-exclamation-circle"></i>
          {msg}
        </strong>,
      );
  };

  const dispatch = useDispatch();
  const navigate = useHistory();
  const location = useParams();

  // Input states
  const [reference, setReference] = useState("");
  const [internalCode, setInternalCode] = useState("");
  const [nom, setNom] = useState("");
  const [description, setDescription] = useState(""); // Added description field
  const [stock, setStock] = useState(0);
  const [minStock, setMinStock] = useState(0);
  const [purchasePrice, setPurchasePrice] = useState(0);
  const [marginPercent, setMarginPercent] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  const [priceIncludingTax, setPriceIncludingTax] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [vat, setVat] = useState(19);
  const [categoryId, setCategoryId] = useState(0);
  const [brandId, setBrandId] = useState(null);
  const [id, setId] = useState(0);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [existingImage, setExistingImage] = useState(null);

  // Options for categories
  const [categories, setCategories] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Options for brands
  const [brands, setBrands] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);

  // Options for VAT
  const vatOptions = [
    { value: 0, label: "0%" },
    { value: 7, label: "7%" },
    { value: 19, label: "19%" },
  ];
  const [selectedVat, setSelectedVat] = useState(vatOptions[2]); // Default to 19%

  // Calculate sale price based on purchase price and margin
  const calculateSalePrice = () => {
    if (purchasePrice && marginPercent) {
      const calculatedPrice = purchasePrice * (1 + marginPercent / 100);
      setSalePrice(parseFloat(calculatedPrice).toFixed(3));
    }
  };

  // Calculate price including tax
  const calculatePriceIncludingTax = () => {
    if (salePrice) {
      const calculatedPrice =
        parseFloat(salePrice) * (1 + parseFloat(vat) / 100);
      setPriceIncludingTax(parseFloat(calculatedPrice).toFixed(3));
    }
  };

  // Update price including tax when salePrice or vat changes
  useEffect(() => {
    calculatePriceIncludingTax();
  }, [salePrice, vat]);

  // Handle image selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.match(/\/(jpg|jpeg|png|gif|webp)$/)) {
        notify(
          2,
          "Seuls les fichiers image (jpg, jpeg, png, gif, webp) sont autorisés",
        );
        return;
      }

      // Validate file size (5MB max)
      if (file.size > 5 * 1024 * 1024) {
        notify(2, "La taille de l'image ne doit pas dépasser 5MB");
        return;
      }

      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  async function submitForm(event) {
    event.preventDefault();

    var required = document.getElementsByClassName("required");
    var isValid = true;

    for (var i = 0; i < required.length; i++) {
      if (required[i] !== undefined) {
        const errorDiv = document.getElementsByClassName("error")[i];
        if (errorDiv) errorDiv.innerHTML = "";
        required[i].style.borderColor = "#ccc";

        // Condition required
        if (validator.isEmpty(required[i].value)) {
          required[i].style.borderColor = "red";
          if (errorDiv) {
            errorDiv.innerHTML = required[i].name + " est obligatoire";
          }
          notify(2, required[i].name + " doit être non vide");
          isValid = false;
        }
      }
    }

    // Validate numbers
    if (
      parseFloat(purchasePrice) <= 0 ||
      parseFloat(salePrice) <= 0 ||
      parseFloat(marginPercent) < 0
    ) {
      notify(2, "Les prix et la marge doivent être positifs");
      isValid = false;
    }

    if (categoryId === 0) {
      notify(2, "Veuillez sélectionner une catégorie");
      isValid = false;
    }

    if (isValid) {
      // Create FormData object
      const formData = new FormData();

      // Append all fields
      formData.append("reference", reference);
      formData.append("internalCode", internalCode);
      formData.append("name", nom);
      formData.append("description", description); // Added description field
      formData.append("stock", parseInt(stock) || 0);
      formData.append("minStock", parseInt(minStock) || 0);
      formData.append("purchasePrice", parseFloat(purchasePrice));
      formData.append("marginPercent", parseFloat(marginPercent));
      formData.append("salePrice", parseFloat(salePrice));
      formData.append("priceIncludingTax", parseFloat(priceIncludingTax));
      formData.append("discount", parseFloat(discount) || 0);
      formData.append("vat", parseFloat(vat));
      formData.append("categoryId", parseInt(categoryId));

      // Append brandId if selected
      if (brandId) {
        formData.append("brandId", parseInt(brandId));
      }

      // Append image if selected
      if (image) {
        formData.append("image", image);
      }

      if (isNaN(location.id) === true) {
        // Create new product
        dispatch(productAdded(formData)).then((data) => {
          if (data.payload && !data.error) {
            notify(1, "Insertion avec succès");
            setTimeout(async () => {
              listeProducts();
            }, 1500);
          } else {
            notify(2, data.payload?.message || "Problème de connexion");
          }
        });
      } else {
        // Update existing product
        dispatch(productUpdated({ id: location.id, data: formData })).then(
          (data) => {
            if (data.payload && !data.error) {
              notify(1, "Modification avec succès");
              setTimeout(async () => {
                listeProducts();
              }, 1500);
            } else {
              notify(2, data.payload?.message || "Problème de connexion");
            }
          },
        );
      }
    }
  }

  useEffect(() => {
    // Load categories
    dispatch(fetchCategories()).then((response) => {
      const cats = response.payload;
      setCategories(cats);
      const options = cats.map((cat) => ({
        value: cat.id,
        label: cat.name,
      }));
      setCategoryOptions(options);
    });

    // Load brands
    dispatch(fetchBrands()).then((response) => {
      const brandsData = response.payload;
      setBrands(brandsData);
      const options = brandsData.map((brand) => ({
        value: brand.id,
        label: brand.name,
      }));
      setBrandOptions(options);
    });

    // Load product if editing
    if (isNaN(location.id) === false) {
      dispatch(productGetById(location.id)).then((product) => {
        const entities = product.payload;

        setReference(entities.reference);
        setInternalCode(entities.internalCode);
        setNom(entities.name);
        setDescription(entities.description || ""); // Added description field
        setStock(entities.stock);
        setMinStock(entities.minStock);
        setPurchasePrice(entities.purchasePrice);
        setMarginPercent(entities.marginPercent);
        setSalePrice(entities.salePrice);
        setPriceIncludingTax(entities.priceIncludingTax);
        setDiscount(entities.discount);
        setVat(entities.vat);
        setCategoryId(entities.categoryId);
        setBrandId(entities.brandId);
        setId(location.id);

        // Set selected VAT
        const vatValue = entities.vat || 0;
        const selectedVatOption =
          vatOptions.find((option) => option.value === vatValue) ||
          vatOptions[2];
        setSelectedVat(selectedVatOption);

        // Set existing image
        if (entities.img) {
          setExistingImage(entities.img);
        }
      });
    }
  }, [location.id, dispatch]);

  // Separate useEffect to set selectedCategory when both categories and product data are loaded
  useEffect(() => {
    if (categories.length > 0 && categoryId) {
      const selectedCat = categories.find((cat) => cat.id === categoryId);
      if (selectedCat) {
        setSelectedCategory({
          value: selectedCat.id,
          label: selectedCat.name,
        });
      }
    }
  }, [categories, categoryId]);

  // Separate useEffect to set selectedBrand when both brands and product data are loaded
  useEffect(() => {
    if (brands.length > 0 && brandId) {
      const selectedBr = brands.find((brand) => brand.id === brandId);
      if (selectedBr) {
        setSelectedBrand({
          value: selectedBr.id,
          label: selectedBr.name,
        });
      }
    }
  }, [brands, brandId]);

  function listeProducts() {
    navigate.push("/products/list");
  }

  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Container>
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={listeProducts}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  Retour à la liste
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form
                  action=""
                  className="form"
                  method=""
                  onSubmit={submitForm}
                >
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">
                        {typeof location.id == "undefined"
                          ? "Ajouter produit"
                          : "Modifier produit"}
                      </Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>Référence </label>
                            <Form.Control
                              defaultValue={reference}
                              placeholder="Référence"
                              name="Référence"
                              type="text"
                              onChange={(value) => {
                                setReference(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col className="pl-1" md="6">
                          <Form.Group>
                            <label>Code Interne </label>
                            <Form.Control
                              defaultValue={internalCode}
                              placeholder="Code Interne"
                              name="Code Interne"
                              type="text"
                              onChange={(value) => {
                                setInternalCode(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col className="pr-1" md="12">
                          <Form.Group>
                            <label>Nom* </label>
                            <Form.Control
                              defaultValue={nom}
                              placeholder="Nom du produit"
                              name="Nom"
                              className="required"
                              type="text"
                              onChange={(value) => {
                                setNom(value.target.value);
                              }}
                            ></Form.Control>
                            <div className="error"></div>
                          </Form.Group>
                        </Col>
                      </Row>

                      {/* Added Description Field */}
                      <Row>
                        <Col className="pr-1" md="12">
                          <Form.Group>
                            <label>Description </label>
                            <Form.Control
                              value={description}
                              placeholder="Description du produit"
                              name="Description"
                              as="textarea"
                              rows={3}
                              onChange={(value) => {
                                setDescription(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col className="pr-1" md="3">
                          <Form.Group>
                            <label>Stock </label>
                            <Form.Control
                              value={stock}
                              placeholder="Stock"
                              type="number"
                              min="0"
                              onChange={(value) => {
                                setStock(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col className="pr-1" md="3">
                          <Form.Group>
                            <label>Stock Minimum </label>
                            <Form.Control
                              value={minStock}
                              placeholder="Stock Minimum"
                              type="number"
                              min="0"
                              onChange={(value) => {
                                setMinStock(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col className="pr-1" md="3">
                          <Form.Group>
                            <label>Catégorie* </label>
                            <Select
                              placeholder="Sélectionner une catégorie"
                              className="react-select primary"
                              classNamePrefix="react-select"
                              value={selectedCategory}
                              onChange={(value) => {
                                setSelectedCategory(value);
                                setCategoryId(value.value);
                              }}
                              options={categoryOptions}
                            />
                            <div className="error"></div>
                          </Form.Group>
                        </Col>
                        <Col className="pl-1" md="3">
                          <Form.Group>
                            <label>Marque </label>
                            <Select
                              placeholder="Sélectionner une marque"
                              className="react-select primary"
                              classNamePrefix="react-select"
                              value={selectedBrand}
                              isClearable={true}
                              onChange={(value) => {
                                setSelectedBrand(value);
                                setBrandId(value ? value.value : null);
                              }}
                              options={brandOptions}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col className="pr-1" md="4">
                          <Form.Group>
                            <label>Prix d'Achat (DT)* </label>
                            <Form.Control
                              value={purchasePrice}
                              name="Prix Achat"
                              className="required"
                              type="number"
                              step="0.001"
                              min="0"
                              onChange={(value) => {
                                setPurchasePrice(value.target.value);
                                calculateSalePrice();
                              }}
                            ></Form.Control>
                            <div className="error"></div>
                          </Form.Group>
                        </Col>
                        {/* <Col className="pr-1" md="4">
                          <Form.Group>
                            <label>Marge (%)* </label>
                            <Form.Control
                              value={marginPercent}
                              placeholder="0"
                              name="Marge"
                              className="required"
                              type="number"
                              step="0.01"
                              min="0"
                              onChange={(value) => {
                                setMarginPercent(value.target.value);
                                calculateSalePrice();
                              }}
                            ></Form.Control>
                            <div className="error"></div>
                          </Form.Group>
                        </Col> */}
                        <Col className="pr-1" md="4">
                          <Form.Group>
                            <label>Prix de Vente (DT)* </label>
                            <Form.Control
                              value={salePrice}
                              placeholder="0.00"
                              name="Prix Vente"
                              className="required"
                              type="number"
                              step="0.001"
                              min="0"
                              onChange={(value) => {
                                setSalePrice(value.target.value);
                              }}
                            ></Form.Control>
                            <div className="error"></div>
                          </Form.Group>
                        </Col>
                        <Col className="pl-1" md="4">
                          <Form.Group>
                            <label>Prix TTC (DT) </label>
                            <Form.Control
                              value={priceIncludingTax}
                              placeholder="0.00"
                              type="number"
                              step="0.001"
                              readOnly
                              style={{ backgroundColor: "#f8f9fa" }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col className="pr-1" md="4">
                          <Form.Group>
                            <label>Remise (%) </label>
                            <Form.Control
                              value={discount}
                              placeholder="0"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              onChange={(value) => {
                                setDiscount(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col className="pl-1" md="4">
                          <Form.Group>
                            <label>TVA (%) </label>
                            <Select
                              placeholder="Sélectionner TVA"
                              className="react-select primary"
                              classNamePrefix="react-select"
                              value={selectedVat}
                              onChange={(value) => {
                                setSelectedVat(value);
                                setVat(value.value);
                              }}
                              options={vatOptions}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md="12">
                          <Form.Group>
                            <label>Image du produit </label>
                            <Form.Control
                              type="file"
                              accept="image/jpeg,image/png,image/gif,image/webp"
                              onChange={handleImageChange}
                            />
                            <Form.Text className="text-muted">
                              Formats acceptés: JPG, JPEG, PNG, GIF, WEBP (Max:
                              5MB)
                            </Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>

                      {(imagePreview || existingImage) && (
                        <Row>
                          <Col md="12">
                            <div className="text-center">
                              <label>Aperçu de l'image: </label>
                              <div>
                                <Image
                                  src={imagePreview || existingImage}
                                  alt="Product preview"
                                  style={{
                                    maxWidth: "200px",
                                    maxHeight: "200px",
                                    objectFit: "contain",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "5px",
                                  }}
                                  thumbnail
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}

                      <Button
                        className="btn-fill pull-right"
                        type="submit"
                        variant="info"
                      >
                        Enregistrer
                      </Button>
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </>
  );
}

export default AjouterProduct;
